import { useState } from "react";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";
import { Switch } from "@/components/ui/switch";
import { Settings, Save, Building, Phone, Mail, Globe } from "lucide-react";
import { toast } from "sonner";

export default function AdminSettings() {
  const [settings, setSettings] = useState({
    labName: "Laboratorio Clínico",
    labCode: "LAB001",
    address: "",
    phone: "",
    email: "",
    website: "",
    taxId: "",
    logo: "",
    enableNotifications: true,
    enableEmailReports: false,
    defaultPriceList: "",
  });

  const handleSave = () => {
    // TODO: Implement save to backend
    toast.success("Configuración guardada");
  };

  return (
    <div className="space-y-6" data-testid="admin-settings-page">
      <div>
        <h1 className="text-2xl font-bold font-['Manrope'] tracking-tight">
          Configuración
        </h1>
        <p className="text-muted-foreground">
          Configure los parámetros generales del sistema
        </p>
      </div>

      <div className="grid gap-6 md:grid-cols-2">
        {/* Información del Laboratorio */}
        <Card>
          <CardHeader>
            <CardTitle className="flex items-center gap-2 text-lg">
              <Building className="h-5 w-5" />
              Información del Laboratorio
            </CardTitle>
          </CardHeader>
          <CardContent className="space-y-4">
            <div className="space-y-2">
              <Label>Nombre del Laboratorio</Label>
              <Input
                value={settings.labName}
                onChange={(e) => setSettings({ ...settings, labName: e.target.value })}
                placeholder="Nombre del laboratorio"
              />
            </div>
            <div className="space-y-2">
              <Label>Código</Label>
              <Input
                value={settings.labCode}
                onChange={(e) => setSettings({ ...settings, labCode: e.target.value })}
                placeholder="Código único"
              />
            </div>
            <div className="space-y-2">
              <Label>RFC / ID Fiscal</Label>
              <Input
                value={settings.taxId}
                onChange={(e) => setSettings({ ...settings, taxId: e.target.value })}
                placeholder="RFC o identificación fiscal"
              />
            </div>
            <div className="space-y-2">
              <Label>Dirección</Label>
              <Textarea
                value={settings.address}
                onChange={(e) => setSettings({ ...settings, address: e.target.value })}
                placeholder="Dirección completa"
                rows={3}
              />
            </div>
          </CardContent>
        </Card>

        {/* Contacto */}
        <Card>
          <CardHeader>
            <CardTitle className="flex items-center gap-2 text-lg">
              <Phone className="h-5 w-5" />
              Información de Contacto
            </CardTitle>
          </CardHeader>
          <CardContent className="space-y-4">
            <div className="space-y-2">
              <Label className="flex items-center gap-2">
                <Phone className="h-4 w-4" />
                Teléfono
              </Label>
              <Input
                value={settings.phone}
                onChange={(e) => setSettings({ ...settings, phone: e.target.value })}
                placeholder="Número de teléfono"
              />
            </div>
            <div className="space-y-2">
              <Label className="flex items-center gap-2">
                <Mail className="h-4 w-4" />
                Correo Electrónico
              </Label>
              <Input
                type="email"
                value={settings.email}
                onChange={(e) => setSettings({ ...settings, email: e.target.value })}
                placeholder="correo@laboratorio.com"
              />
            </div>
            <div className="space-y-2">
              <Label className="flex items-center gap-2">
                <Globe className="h-4 w-4" />
                Sitio Web
              </Label>
              <Input
                value={settings.website}
                onChange={(e) => setSettings({ ...settings, website: e.target.value })}
                placeholder="https://www.laboratorio.com"
              />
            </div>
          </CardContent>
        </Card>

        {/* Opciones del Sistema */}
        <Card className="md:col-span-2">
          <CardHeader>
            <CardTitle className="flex items-center gap-2 text-lg">
              <Settings className="h-5 w-5" />
              Opciones del Sistema
            </CardTitle>
          </CardHeader>
          <CardContent className="space-y-4">
            <div className="flex items-center justify-between">
              <div>
                <Label>Notificaciones del Sistema</Label>
                <p className="text-sm text-muted-foreground">
                  Recibir notificaciones sobre órdenes y resultados
                </p>
              </div>
              <Switch
                checked={settings.enableNotifications}
                onCheckedChange={(checked) =>
                  setSettings({ ...settings, enableNotifications: checked })
                }
              />
            </div>
            <div className="flex items-center justify-between">
              <div>
                <Label>Envío de Reportes por Email</Label>
                <p className="text-sm text-muted-foreground">
                  Enviar automáticamente los resultados por correo electrónico
                </p>
              </div>
              <Switch
                checked={settings.enableEmailReports}
                onCheckedChange={(checked) =>
                  setSettings({ ...settings, enableEmailReports: checked })
                }
              />
            </div>
          </CardContent>
        </Card>
      </div>

      <div className="flex justify-end">
        <Button onClick={handleSave}>
          <Save className="h-4 w-4 mr-2" />
          Guardar Configuración
        </Button>
      </div>
    </div>
  );
}
